import {StringTranslations} from '../../../common/types/StringTranslations';

export interface DictionaryItem {
  readonly type: DictionaryType;
  readonly alias: string;
  readonly value: StringTranslations;
}

export interface DictionaryItemListing {
  readonly type: DictionaryType;
  readonly alias: string;
  readonly value: string;
}

export interface UpdateDictionaryItem {
  readonly value: StringTranslations;
}

export enum DictionaryType {
  PLACE_TYPE = 'PLACE_TYPE',
  ARTISTIC_OBJECT_TYPE = 'ARTISTIC_OBJECT_TYPE',
  PLACE_SECTION = 'PLACE_SECTION',
  ARTISTIC_OBJECT_SECTION = 'ARTISTIC_OBJECT_SECTION',
  PAGE_SECTION = 'PAGE_SECTION'
}

export enum ArtisticObjectSections {
  HSTR = 'HSTR', // History and Research Status
  PRSR = 'PRSR', // Preservation State / Conservation Notes
  ANSK = 'ANSK', // Inscriptions
  SNTR = 'SNTR', // Signatures
  FTNT = 'FTNT', // Footnotes
  PPLK = 'PPLK', // Sources / Bibliography
  NTES = 'NTES'  // Notes
}

export enum PlaceSections {
  TSKP = 'TSKP', // Place Description
  PPLK = 'PPLK'  // Sources / Bibliography
}

export const DictionaryTypeLabels: Record<DictionaryType, string> = {
  [DictionaryType.PLACE_TYPE]: 'Place Types',
  [DictionaryType.ARTISTIC_OBJECT_TYPE]: 'Artistic Object Types',
  [DictionaryType.PLACE_SECTION]: 'Place Sections',
  [DictionaryType.ARTISTIC_OBJECT_SECTION]: 'Artistic Object Sections',
  [DictionaryType.PAGE_SECTION]: 'Page Sections'
};
